import { useEffect } from 'react'

import { useWindowLocation } from 'utils/windowLocation'

// This hook is used to notify other tabs when the employer is switched
// to force a page reload in all tabs.
export function useEmployerSwitchSync () {
  const { reload } = useWindowLocation()

  useEffect(() => {
    const channel = new BroadcastChannel('employer-switch')

    const handleMessage = (event: MessageEvent) => {
      if (event.data.type === 'EMPLOYER_SWITCHED') {
        reload()
      }
    }

    channel.addEventListener('message', handleMessage)
    return () => channel.close()
  }, [])

  const notifyOtherTabs = (employerId: string) => {
    const channel = new BroadcastChannel('employer-switch')
    channel.postMessage({ type: 'EMPLOYER_SWITCHED', payload: { employerId } })
    channel.close()
  }

  return { notifyOtherTabs }
}
